// extracted by mini-css-extract-plugin
export default {"container":"styles_container__+DMTx","content":"styles_content__evI+v"};